import { Card, CardContent, CardHeader, Typography } from "@gti-controls-v2/web-core";
import { ConsumoPorTipo } from "./ConsumoPorTipo";
import useTranslation from "../../../hooks/useTranslation";

export const ConsumosDesktopLeftPanel = (props) => {
    
    const { t } = useTranslation();

    return (
        <>
            <Card sx={{ mt: 6.5 }}>
                <CardHeader 
                    title={
                        <Typography sx={{ fontSize: "22px", color: "#4f4f4f", "font-weight": "500" }}>
                            {t("sistema.consumos.titulos.consumosPorTipo")}
                        </Typography>} 
                />
                <CardContent>
                    {props.cortes.map(item => (
                        // Using item.CafeProdID as a key to ensure uniqueness
                        <ConsumoPorTipo key={item.CafeProdID} tipo={item.CafeProdNombre} cantidad={item.Conteo} />
                    ))}
                </CardContent>
            </Card>
        </>
    )
}
